import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/CardsSprite.css";
import "../../../assets/topstudio/styles/andarbahar.css";
import "../../../assets/topstudio/styles/roulet.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import GameTimer from "./components/GameTimer";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import { isMobile } from "react-device-detect";
import Volume from "./Volume";
import AndarBaharResult from "../../client/tp-studio/tp-result/AndarBaharResult";
import AndarbaharRules from "./pop-up/andarbahar-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

function Andarbahar() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);

  const [showRules, setShowRules] = useState(false);
  const [open, setOpen] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [profileData, setProfileData] = useState(null);
  const [lastRound, setLastRound] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [resultList, setResultList] = useState([]);

  const [placedBets, setPlacedBets] = useState([]);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const [andarBook, setAndarBook] = useState(0);
  const [baharBook, setBaharBook] = useState(0);

  const [winnerAndar, setWinnerAndar] = useState(false);
  const [winnerBahar, setWinnerBahar] = useState(false);
  const [cardsSettled, setCardsSettled] = useState(false);
  const cardsSettleTimerRef = useRef(null);

  const [resultData, setResultData] = useState([]);
  const displayRunnerName = (runnerName) => {
    if (runnerName == "b1") return "Bahar";
    else if (runnerName == "b2") return "Andar";

    return runnerName.replace(/\b\w/g, function (c) {
      return c.toUpperCase();
    });
  };

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "andarbahar_virtual"
    });

    setPlacedBets(placedBets.data);
  }
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      //console.log("placeBetObject: ", placeBetObject);
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          getPlacedBets();
          setShowBetSlipPopup(false);
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "andarbahar_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        setAndarBook(obj.Andar);
        setBaharBook(obj.Bahar);
      }
    }
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketType
  ) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "andarbahar_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;
    //console.log("teamname->", teamname);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    //placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;
    placeBetObject.market_type = marketType;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "andarbahar_virtual"
  });
  const [baharCards, setBaharCards] = useState([]);
  const [andarCards, setAndarCards] = useState([]);
  const payload = data?.data?.data;
  const payloadResult = data?.data?.result;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log(payload);
  const [displayLoader, setDisplayLoader] = useState(true);
  const normalizeCards = (cards) => {
    if (Array.isArray(cards)) return cards;

    if (typeof cards === "string") {
      return cards
        .split(",")
        .map((c) => c.trim())
        .filter(Boolean);
    }

    return [];
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    updateUserData(data?.user);

    if (lastRound !== payload?.cat_mid) {
      setPlacedBets([]);
      setAndarBook(0);
      setBaharBook(0);
      setWinnerAndar(false);
      setWinnerBahar(false);
      setCardsSettled(false);
      setLastRound(payload?.cat_mid);
    }

    setB2Val(payload?.b2);
    setB1Val(payload?.b1);

    if (payload?.evt_status === "CLOSED") {
      const allCards = normalizeCards(payload?.cards_desc);

      setBaharCards([]);
      setAndarCards([]);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);

      const timers = [];

      allCards.forEach((card, index) => {
        const timer = setTimeout(() => {
          if (index % 2 === 0) {
            setBaharCards((prev) => [...prev, card]);
          } else {
            setAndarCards((prev) => [...prev, card]);
          }
        }, index * 1000);

        timers.push(timer);
      });

      cardsSettleTimerRef.current = setTimeout(() => {
        if (payload?.result == 1) {
          setWinnerAndar(true);
          setWinnerBahar(false);
        } else if (payload?.result == 2) {
          setWinnerAndar(false);
          setWinnerBahar(true);
        }
        setCardsSettled(true);
      }, allCards.length * 1000);

      return () => {
        timers.forEach(clearTimeout);
        clearTimeout(cardsSettleTimerRef.current);
      };
    } else {
      setBaharCards([]);
      setAndarCards([]);
      setCardsSettled(false);
      setWinnerAndar(false);
      setWinnerBahar(false);
    }
  }, [payload?.evt_status, payload?.cards_desc, payload?.left_time]);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  //console.log(data?.data?.data);

  useEffect(() => {
    document.documentElement.classList.add("roulette-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("roulette-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "andarbahar_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="roulette-scope roulette-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row ExMainCardbundle lobby-ctn"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="col-6  col-md-6 titlebarname">
                              <p style={{ marginBottom: "-6px", marginTop: 6 }}>
                                AndarBahar
                              </p>
                            </div>{" "}
                            <div className="col-6 col-md-6 inline-block Gameidcol">
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>

                                <button
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>

                                <button
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                            <AndarbaharRules
                              show={showRules}
                              onClose={() => setShowRules(false)}
                            />
                          </div>
                        </>

                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          {/* Top: users + sound + timer */}
                          <div className="col-12 timerDiv2">
                            <div className="andarbahar-top-left">
                              <div className="Connectedclients mt-1">
                                <i
                                  aria-hidden="true"
                                  className="fa fa-user mr-1"
                                  style={{ fontSize: "14px", color: "white" }}
                                />
                                <b>
                                  <span id="UsersCount" className="number">
                                    63
                                  </span>
                                </b>
                              </div>

                              <div
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                                className="volume-wrapper"
                              >
                                <Volume />
                              </div>
                            </div>

                            <GameTimer leftTime={payload?.left_time} />
                          </div>

                          {/* Table-style layout: long rows for Player A & B + right column card */}
                          <div className="row">
                            {/* LEFT: wide column with long rows */}
                            <div className="col-12 col-md-10 mb-4">
                              <div style={{ display: "list-item" }}>
                                {/* Player A row */}
                                <div className="andarbahar-player-item">
                                  <span
                                    className="name"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Bahar
                                  </span>

                                  <div className="andarbahar-player-card">
                                    {baharCards.map((card, index) => (
                                      <img
                                        key={index}
                                        src={`/assets/galaxy/img/cards3/${card}.svg`}
                                        alt={`Card ${index + 1}`}
                                        className="andarbahar-cards"
                                      />
                                    ))}
                                  </div>
                                </div>

                                {/* Player B row */}
                                <div
                                  className="andarbahar-player-item"
                                  style={{ marginTop: "6px" }}
                                >
                                  <span
                                    className="name"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Andar
                                  </span>
                                  <div className="andarbahar-player-card">
                                    {andarCards.map((card, index) => (
                                      <img
                                        key={index}
                                        src={`/assets/galaxy/img/cards3//${card}.svg`}
                                        alt={`Card ${index + 1}`}
                                        className="andarbahar-cards"
                                      />
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* RIGHT: narrow column with center/dealer/community card */}
                            <div
                              className="col-12 col-md-2"
                              style={{ margin: "auto" }}
                            >
                              <div style={{ display: "list-item" }}>
                                <div
                                  className="player-item big-card-margin"
                                  style={{ marginLeft: "-10px" }}
                                >
                                  <span className="name"></span>
                                  <div>
                                    <div className="andarbahar-player-card andarbahar-single">
                                      <div
                                        id="BFBCardHandView"
                                        className="BFBCardHandViewDealerab"
                                      >
                                        <div
                                          id="BFBCardFanView"
                                          className="BFBCardFanViewab ab-mobile-single-card"
                                        >
                                          <center>
                                            <img
                                              src={`/assets/galaxy/img/cards3/${payload?.j1}.svg`}
                                              className="andarbahar-single-cards"
                                            />
                                          </center>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx] == 1 ? "A" : "B"}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{payload?.cat_mid}</div>
                            </div>
                          </div>
                        </center>

                        <div
                          className="section-blur"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                    alt=""
                                  />
                                </i>{" "}
                                <span>Main </span>
                              </span>
                            </p>
                            <div className="ab-market-overarround pr-3">
                              <span></span>
                              <strong>Back</strong>
                            </div>
                            <div className="ab-market-overarround ab-market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>

                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  winnerBahar && cardsSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                                id="b2Sucess"
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Bahar
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  baharBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  baharBook > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(baharBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b2span"
                                  data-teamname="Bahar"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "bahar",
                                      "bahar",
                                      b2Val,
                                      "m"
                                    )
                                  }
                                >
                                  {b2Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  winnerAndar && cardsSettled
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                                id="b1Sucess"
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Andar
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  andarBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  andarBook > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(andarBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Andar"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "andar",
                                      "andar",
                                      b1Val,
                                      "m"
                                    )
                                  }
                                >
                                  {b1Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <AndarBaharResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>{displayRunnerName(bet.rnr)} - ({bet.cat_mid})</td>
                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`

        .ExMainCardbundle .runner-runner .price-price.price-lay.ml-4.mb-show {
    background-color: #ffe0e1;
}
            .row {
              margin-left: 0 !important;
              margin-right: 0!important;
            }
            @media (max-width: 768px) {
              .col-md-2 {
                max-width: 100%;
                flex: 0 0 100%;
                display: flex;
                justify-content: center;
              }
              .roulette-scope .BPGmaindiv {
                padding: 0 !important;
              }
              .roulette-scope .top-nav {
                padding-left: 0 !important;
              }
            }
            .cards-layout.blackjack {
              height: 270px;
            }

            @media (max-width: 576px) {
              .cards-layout.blackjack {
                height: 325px;
              }
              .andarbahar-single-cards{
                margin-top: 3px !important;
              }
              .col-md-8 {
                padding-left: 5px;
                padding-right: 5px;
              }
              .ab-market-overarround {
                width: 63px;
              }
              .andarbahar-player-card.andarbahar-single {
                padding-top: 0 !important;
              }
              .andarbahar-single-cards {
                  width: 40px;
                  border-radius: 10px;
                  max-height: 50px;
                  margin-top: 10px;
              }
              .andarbahar-player-card.andarbahar-single {
                height: 60px !important;
                width: 380px !important;
                margin-top: -18px;
                padding: 10px;
                box-sizing: border-box;
                margin-right:-10px;
              }
              .player-item.big-card-margin {
                width: 100%;
              }
              .BFBCardHandViewDealerab {
                width: 100%;
                display: flex;
                justify-content: center;
              }
              .col-md-4{
                padding-top: 5px; 
                padding-left: 5px;
                padding-right: 5px;
              }
              .player-item.big-card-margin{
                  margin-left:0;
              }
            }
            .andarbahar-single-cards{
              margin-top: -16px;
            }
            .andarbahar-player-card.andarbahar-single {
              height: 50px;
              padding-top: 20px;
              width: 140px;
            }
            .andarbahar-cards{
              margin-top: 5px;
            }
            .roulette-scope .home-content {
              margin-top: 0 !important;
            }
            .roulette-scope .andarbahar-player-card {
              background: none;
              backdrop-filter: none;
            }
            .roulette-scope .cards-layout.blackjack::before {
              top: -20px;
            }
            .roulette-scope .andarbahar-top-left {
              position: absolute;
              top: 6px;
              left: 20px;
              z-index: 1001;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 4px;
            }
            .roulette-scope .andarbahar-top-left .Connectedclients {
              position: relative;
              top: auto;
              left: auto;
            }
            .roulette-scope .volume-wrapper {
              position: relative;
              top: auto;
              left: auto;
              z-index: 1001;
              margin: 10px 0 0 7px;
              height: auto;
            }
            .roulette-scope .volume-wrapper .sound-icon {
              position: relative;
              top: auto;
              right: auto;
              left: 0;
              transform: scale(0.75);
              transform-origin: left center;
            }
          `}
      </style>
    </div>
  );
}

export default Andarbahar;
